module.exports = __webpack_public_path__ + "img/clap2.7e0d3176.png";